import * as Phaser from "phaser"
import type { EnemyData, GameSprite } from "../../types"
import { type EnemyState, StatefulEnemyRuntime } from "../enemy-system"

type GunPodState = "approach" | "hold" | "retreat"

function clampEnemyY(y: number): number {
  return Phaser.Math.Clamp(y, 80, 560)
}

export class GunPodEnemy extends StatefulEnemyRuntime<GunPodState> {
  private retreatTargetY = 0

  public constructor(sprite: GameSprite, enemyData: EnemyData) {
    const states: EnemyState<GunPodState>[] = [
      {
        name: "approach",
        behaviorState: "flying",
        animationState: "flying",
        canFire: false,
        update: (context) => {
          const { sprite, enemyData, time, delta, scrollCompensation } = context
          const homeY = enemyData.homeY ?? sprite.y
          sprite.x = Phaser.Math.Linear(
            sprite.x,
            (enemyData.homeX ?? sprite.x) - 210,
            1 - (1 - 0.1) ** (delta / 16.6),
          )
          sprite.y = Phaser.Math.Linear(
            sprite.y,
            clampEnemyY(homeY + Math.sin(time / 220) * 14),
            1 - (1 - 0.08) ** (delta / 16.6),
          )
          enemyData.vx = scrollCompensation
          sprite.setAngle(Math.sin(time / 100) * 6)
          if (sprite.x <= (enemyData.homeX ?? sprite.x) - 210) {
            return "hold"
          }
          return null
        },
      },
      {
        name: "hold",
        behaviorState: "hovering",
        animationState: "hovering",
        canFire: true,
        update: (context) => {
          const { sprite, enemyData, time, delta, scrollCompensation } = context
          const holdX = (enemyData.homeX ?? sprite.x) - 210
          const homeY = enemyData.homeY ?? sprite.y
          sprite.x = holdX + Math.sin(time / 180) * 4
          sprite.y = Phaser.Math.Linear(
            sprite.y,
            clampEnemyY(homeY + Math.sin(time / 260) * 18),
            1 - (1 - 0.06) ** (delta / 16.6),
          )
          enemyData.vx = scrollCompensation
          sprite.setAngle(Math.sin(time / 80) * 3)
          if (context.stateTime >= 2600) {
            this.retreatTargetY = clampEnemyY(
              homeY + (sprite.y < homeY ? -80 : 80) + Math.sin(time / 90) * 16,
            )
            return "retreat"
          }
          return null
        },
      },
      {
        name: "retreat",
        behaviorState: "retreating",
        animationState: "tracking",
        canFire: false,
        update: (context) => {
          const { sprite, enemyData, time, delta, scrollCompensation } = context
          sprite.x += (2.6 + scrollCompensation) * (delta / 16.6)
          sprite.y = Phaser.Math.Linear(
            sprite.y,
            this.retreatTargetY,
            1 - (1 - 0.08) ** (delta / 16.6),
          )
          enemyData.vx = scrollCompensation
          sprite.setAngle(-14 + Math.sin(time / 90) * 6)
          if (sprite.x > sprite.scene.scale.width + 100) sprite.destroy()
          return null
        },
      },
    ]

    super(sprite, enemyData, "approach", states)
  }
}
